// @flow
import React from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import Icon from '../../../common/Icon';
import theme from '../../../../theme-config';

const EyeIcon = (props: Props) => {
  const iconName = props.isPasswordVisible ? 'eye-with-line' : 'eye';
  return (
    <TouchableOpacity
      activeOpacity={0.7}
      onPress={props.onPress}
      hitSlop={{ top: 5, bottom: 5, left: 5, right: 5 }}
      style={styles.touchableIconStyle}
    >
      <Icon name={iconName} size={17} color={theme.signUpInputTextColor} />
    </TouchableOpacity>
  );
};

type Props = {
  isPasswordVisible: boolean,
  onPress: Function,
};

const styles = StyleSheet.create({
  touchableIconStyle: {
    backgroundColor: 'transparent',
    padding: 5,
  },
});

export default EyeIcon;
